export default __webpack_public_path__ + "andrew.5175a096.jpg";